module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 9.807125aa.png";